import { render, staticRenderFns } from "./CustomOption.vue?vue&type=template&id=28135b4d"
import script from "./CustomOption.vue?vue&type=script&lang=js"
export * from "./CustomOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports